/**
 * Explorer constants
 * @author gabriel.carmo
 */
export const BASE_API_URL = '/api/1/';
export const APPLICATION_IDENTIFIER = 'main';
export const SYSTEM = '_system';
export const CLASS_COLLECTION = '_class';
export const CLASS_COLLECTION_ID = '000000000000000000000000';
export const INTERNAL_CLASS_COLLECTION_ID = '000000000000000000000777';
export const USER_COLLECTION_ID = '000000000000000000000002';
export const USER_COLLECTION = '_user';
export const FIELD_COLLECTION_ID = '000000000000000000000001';
export const METHOD_COLLECTION_ID = '000000000000000000000006';
export const INNER_METHOD_CLASS_ID = '000000000000000000000077';
export const ECLASS_EXTENSION_COLLECTION_ID = '000000000000000000000901';
export const INTERCEPTOR_METHOD_CLASS_ID = '000000000000000000000902';
export const VIEW_COLLECTION_ID = '000000000000000000000008';
export const NOTIFICATION_COLLECTION_ID = '5f89d6ac9795af276dc0b18b';
export const MASK_COLLECTION_ID = '0fff00000000000000001911';
export const CLASS_ID_PACKAGE = '_classId';

export const EMAIL_COLLECTION_ID = 'ad0000000000000000000004';
export const EMAIL_COLLECTION = '_email';

export const FILE_CLASS_ID = '000000000000000000000051';
export const PROCESS_INSTANCE_CLASS_ID = '595c20500000000000000214';
export const ORGANIZATION_COLLECTION_ID = '000000000000000000000003';

export const SYBOX_COLLECTION_ID = '000000000000000000000100';
export const PARAMETER_INTERFACE = '000000000000000000000779';
export const USER_WORKSPACE_PREFERENCES_COLLECTION_ID = '000000ef19062a47fd3ff8ec';
export const USER_PREFERENCES_COLLECTION_ID = '5b16d9acf867444588889011';
export const PACKAGE_COLLECTION_ID = '000000000000000000000015';
export const WORKSPACE_COLLECTION_ID = '000000000000000000000007';
export const ANALYTICS_COLLECTION_ID = '000000000000000000000046';
export const QUEUE_MESSAGE_COLLECTION_ID = '000000000000000000000086\n';
export const LAST_UPDATE_DATE = '_lastUpdateDate';
export const CREATION_DATE = '_creationDate';

export const LOGGED_USER_MAP = 'explorer_user_map';
export const LOGGED_USER = 'explorer_user';
export const CURRENT_WORKSPACE = 'explorer_current_workspace';
export const CURRENT_LANGUAGE = 'explorer_current_language';
export const USER_WORKSPACE_PREFERENCES = 'explorer_user_workspace_preferences';

// Elasticsearch constants
export const UNEMBEDDED_REFERENCES = '_refTracking.referenceObjects';

// Constant to maintain compatibility with versions older than 7.3. Remove this code after complete rebuild of orgs in 7.3.
export const UNEMBEDDED_REFERENCES_FOR_COMPATIBILITY = '_unembeddedReferences';

// QueryParam key for EOBject fields
export const OBJECT_PATH = '_objectPath';

// Identifier for _workspace class
export const WORKSPACE_IDENTIFIER = '_workspace';

// Dot constant
export const DOT = '.';

// Developer group ID
export const DEVELOPER_GROUP_ID = 'eba000000000000000000111';

// Class list view ID
export const CLASS_LIST_VIEW_OBJECT_ID = '000000000000000000000049';

// Object list view ID
export const OBJECT_LIST_VIEW_OBJECT_ID = '000000000000000000000050';

// _object interface class ID
export const OBJECT_INTERFACE_ID = '000000000000000000000087';

// _userTask interface class ID
export const USER_TASK_INTERFACE_ID = '595c20500000000000000215';

// User token cookie name
export const USER_TOKEN_COOKIE_NAME = 'JW-UserToken';

// Supported languages
export const SUPPORTED_LANGUAGES = ['pt', 'en', 'es'];

// Default language
export const DEFAULT_LANGUAGE = 'pt';

// Core module preferences class
export const CORE_GENERAL_PREFERENCES_CLASS_ID = '61795c524297ca5d8b5961a1';

// Security module preferences class
export const SECURITY_PREFERENCES_CLASS_ID = '61795d924297ca5d8b5ffce6';

// IDE module preferences class
export const IDE_PREFERENCES_CLASS_ID = '620a8ee704bf1f50babd7120';

// Wokspace module preferences class
export const USER_WORKSPACE_PREFERENCES_CLASS_ID = '6297c4daa63af66f947763ba';

// New workspace views class
export const VIEW_CLASS_ID = '61b8d0d251839b4307f66ba6';

// Single object view workspace
export const SINGLE_OBJECT_VIEW_WORKSPACE = '62a34ea8ebf26b6f23bedab7';

// Custom fields class
export const CUSTOM_FIELDS_CLASS_ID = '62bf55cf9871ee4b97855c18';

// Working Unit class id
export const WORKING_UNIT_CLASS_ID = '6202ae62f271181173570402';

// Notification class id
export const NOTIFICATION_CLASS_ID = '5f89d6ac9795af276dc0b18b';

// Max search size for select options
export const MAX_SEARCH_SIZE_SELECT_OPTIONS = 100;

export const WORKSPACE_MESSAGES_BUNDLE_ID = '62c82a86d90ec848c8fa59ca';

export const ONE_UI_API_CLASS_ID = '6405f1f76bdd5875e4293c40';

// User Access Interface
export const USER_ACCESS_INTERFACE = '000000000000000000000070';
